import { Component, OnInit } from '@angular/core';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent, IsEmptyFilterOperatorComponent } from '@progress/kendo-angular-grid';
import { process, State, SortDescriptor } from '@progress/kendo-data-query';
import { AdminService } from '../../../../../core/services/admin.service';
import { IErrorList } from '../../../../../core/models/index';

@Component({
  selector: 'app-error-dashboard',
  templateUrl: './error-dashboard.component.html',
  styleUrls: ['./error-dashboard.component.scss']
})
export class ErrorDashboardComponent implements OnInit {

  errorLoading: boolean;
  errorGridView: GridDataResult;
  IErrorList: IErrorList[];

  constructor(private adminService: AdminService) { }

  ngOnInit() {

    this.loaderrorGrid();
  }

  errorLbl = {
    errormessage: "Error Message",
    errordetails: "Error Details",
    errortype: "Error Type",
    date: "Date",

  }



  //#region Grid data binding
  public loaderrorGrid(): void {
    this.errorLoading = true;
    this.adminService.getErrorList().subscribe((response) => {
      this.IErrorList = response;
      this.binderrorGrid();
      this.errorLoading = false;

    });
  }
  //#endregion

  //#region pagination, sorting,filtering for grid

  public errorGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'errorId',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };
  public binderrorGrid(): void {
    const data = this.IErrorList;
    this.errorGridView = process(data, this.errorGridstate);
  }

  public errorGridSortChange(sort: SortDescriptor[]): void {
    this.errorGridstate.sort = sort;
    this.binderrorGrid();
  }
  public errorGridPageChange({ skip, take }: PageChangeEvent): void {
    this.errorGridstate.skip = skip;
    this.errorGridstate.take = take;
    this.binderrorGrid();
  }

  public errorDataStateChange(state: DataStateChangeEvent): void {
    this.errorGridstate = state;
    this.binderrorGrid();
  }
  //#endregion

  //#endregion

}
